import { Stack, Text } from '@mantine/core';

import { PublicationContent } from '@/module/Author/Publication/components/PublicationContent';

import { Content, EditButtonLink } from '@/core/components';

import { AuthorList, BdiList, PublicationPages, PublisherLink } from '@feature/utils';

import { ViewCitationsButton } from '../Citation/components/ViewCitationsButton';
import { TranslationProofAction } from './Proof';
import { TranslationDeleteButton } from './components/TranslationDeleteButton';
import { Translation } from './model/TranslationTypes';

interface TranslationViewProps {
  translation: Translation;
}

export function TranslationView({ translation }: TranslationViewProps) {
  const { authors, noOfPages, publisher, startPage, endPage, bookName, publisherType, bdis } = translation;

  return (
    <Stack>
      <PublicationContent
        publication={translation}
        authorsNo={authors.length}
        editAction={
          <EditButtonLink
            size="xs"
            miw="100px"
          />
        }
        deleteAction={<TranslationDeleteButton translationId={translation.id} />}
      />
      <ViewCitationsButton
        entityId={translation.id}
        entityType="TRANSLATION"
      />
      <Content type="full">
        <Stack gap="xs">
          {publisher && (
            <PublisherLink
              publisherId={publisher.id}
              title={publisher.title}
            />
          )}
          {publisherType && <Text>Tip editura: {publisherType.name}</Text>}
          <PublicationPages
            noOfPages={noOfPages ?? 0}
            endPage={endPage ?? 0}
            startPage={startPage ?? 0}
          />
          {bookName && <Text>{bookName}</Text>}
          <BdiList bdis={bdis} />
        </Stack>
      </Content>
      <Content type="full">
        <AuthorList authors={authors} />
      </Content>
      <TranslationProofAction
        translationId={translation.id}
        authors={authors}
      />
    </Stack>
  );
}
